import React from "react";
import { type FileItem, type FolderItem } from "@/types/fse";
import { type RightDrawerContentType } from "@/components/feature/layout/right-sidebar/rightDrawer";
import { CitationInfo } from "@/views/chat/types";
import { CurrentPdfContext } from "@/contexts/setPdfContext.consts";

export const CurrentPdfProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [rootItem, setRootItem] = React.useState<FolderItem | FileItem>();
  const [currentPdfId, setCurrentPdfId] = React.useState<string | null>(null);
  const [isRightDrawerVisible, setIsRightDrawerVisible] = React.useState<boolean>(false);
  const [rightDrawerContent, setRightDrawerContent] = React.useState<RightDrawerContentType>(null);
  const [currentCitation, setCurrentCitation] = React.useState<CitationInfo | null>(null);
  const [selectedFiles, setSelectedFiles] = React.useState<string[]>([]);

  const handleFileSelect = React.useCallback((file: FileItem, isSelected: boolean) => {
    setSelectedFiles(prev => {
      if (!prev.includes(file.id) && isSelected) {
        return [...prev, file.id];
      } else {
        return prev.filter(id => id !== file.id);
      }
    });
  }, []);

  const handleCitationClick = (citation: CitationInfo) => {
    console.log("Citation clicked:", citation);
    setCurrentPdfId(citation.fseId); // Use citation.documentId to load the correct PDF
    setRightDrawerContent("pdf");
    setIsRightDrawerVisible(true);
    setCurrentCitation(citation);
  };

  return (
    <CurrentPdfContext.Provider
      value={{
        rootItem,
        setRootItem,
        selectedFiles,
        handleFileSelect,
        setSelectedFiles,
        currentPdfId,
        setCurrentPdfId,
        isRightDrawerVisible,
        setIsRightDrawerVisible,
        rightDrawerContent,
        setRightDrawerContent,
        handleCitationClick,
        currentCitation,
        setCurrentCitation,
      }}
    >
      {children}
    </CurrentPdfContext.Provider>
  );
};
